import {FormControl, FormGroup, Validators} from "@angular/forms";

export interface AddressModel {
  id?: string;
  name1?: string;
  name2?: string;
  line1?: string;
  line2?: string;
  city?: string;
  region?: string;
  postalCode?: string;
  country?: string;
  name?: string;
  businessPartnerId?: string;
}

export interface TypedAddress {
  type?: string;
  address?: AddressModel;
}

export function addressModelFactory(json?: any): AddressModel {
  json = json || {};

  return {
    id: json.id || "",
    name1: json.name1 || "",
    name2: json.name2 || "",
    line1: json.line1 || "",
    line2: json.line2 || "",
    city: json.city || "",
    region: json.region || "",
    postalCode: json.postalCode || "",
    country: json.country_id || json.country || "",
    name: json.name || "",
    businessPartnerId: json.businessPartnerId || "",
  };
}

export function addressModelFormGroup(address?: AddressModel): FormGroup {
  address = address || addressModelFactory();

  return new FormGroup({
    name1: new FormControl(address.name1, [Validators.required, Validators.maxLength(100)]),
    name2: new FormControl(address.name2, [Validators.maxLength(100)]),
    line1: new FormControl(address.line1, [Validators.required, Validators.maxLength(100)]),
    line2: new FormControl(address.line2, [Validators.maxLength(100)]),
    city: new FormControl(address.city, [Validators.required, Validators.maxLength(40)]),
    region: new FormControl(address.region, [Validators.maxLength(40)]),
    postalCode: new FormControl(address.postalCode, [Validators.required, Validators.maxLength(10)]),
    country: new FormControl(address.country, [Validators.required, Validators.maxLength(2)]),
    businessPartnerId: new FormControl(address.businessPartnerId, [Validators.maxLength(11)]),
  });
}

export function addressDifferenceListFactory(rows: any[]) {
  if (!rows) rows = [];
  return rows.map(it => ({
    tmcSite: addressModelFactory(it.tmcSite),
    externalSite: addressModelFactory(it.externalSite),
  }));
}
